module.exports = __webpack_public_path__ + "static/media/11.f120c39b.svg";